import React, { Component } from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import ReactLoading from 'react-loading';

export default class FaqLists extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listOfPositions: [],
      createDate:'',
      author: '',
      authorUrl: '',
      otherTag1: '',
      otherTag2: '',
      otherTag3: '',
      loading: true,
      imgLoad: false
    }
    this.handleImageOnLoad = this.handleImageOnLoad.bind(this); 
  }
  handleImageOnLoad() {
    this.setState({
      imgLoad: true
    })
  }

  componentDidMount() {
    window.scrollTo(0,0);
    setTimeout(() => this.setState({ loading: false }), 1500);
    var img = new window.Image();
    img.onload = this.handleImageOnLoad;
    const postListRef = firebase.database().ref('faq/');
    postListRef.on('value', snap => {
      snap.forEach((child) => {
        const previousList = this.state.listOfPositions;
        previousList.push({
          createDate: child.val().createDate,
          createTime: child.val().createTime,
          id: child.val().id,
          userId: child.val().child,
          displayName: child.val().displayName,
          photoURL: child.val().photoURL ? child.val().photoURL : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/webSiteImages%2FcmTable1.jpg?alt=media&token=8733a0f8-db9a-4b23-b443-5f86203e515f',
          title: child.val().title,
          info: child.val().info,
          ansCount: child.val().ansCount
        })
        this.setState({
            listOfPositions: previousList.reverse()
        })
      })
    })
  }


  render() {
    const { loading } = this.state;
    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }
    var { className } = this.props;
    var checkImg = className ? className + ' image' : 'image';
    if (this.state.imgLoad) {
      checkImg += ' image-loaded';
    }
    const listOfPositions = this.state.listOfPositions.map(position =>
      <article key={position.id} className="faqBox">
      <Link to={"/Faqs/" + position.id} target="_blank">
        <div className='faqListBox' style={{position: 'relative'}} >
           <img
            className={checkImg}
            onLoad={this.handleImageOnLoad}
            src={position.photoURL}
            alt="圖片消失了 ><" 
            title={position.displayName} 
            />
        </div>
        <h1 style={{textOverflow: 'ellipsis', whiteSpace:'nowrap', overflow:'hidden', width:'90%' }} >{ position.title }</h1>
        <p>{position.info}</p>
        <div style={{display: 'block', background: '#23c7c9', color: '#fff', textAlign: 'center', padding: '7px 15px', borderRadius: 20, margin: '0 0 15px'}}>我要回答</div>
      </Link>
    </article>
   )
    
    return(
      <div className="hasPadding">
       <div className="container">
        <div className="row">
        <MetaTags>
            <title>草學藥事 || 有事就問</title>
            <meta id="og-title" property="og:title" content="有事就問" />
        </MetaTags>
        <Link to="/UserProfile/FAQ" target="_blank" className="faqBtn" >我要發問</Link>
         <div className="masonry">
          {listOfPositions}
         </div>
        </div>
       </div>
      </div>
    )
  }
}

const Jeyu = {
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  }
}


// WEBPACK FOOTER //
// ./src/post/FaqLists.js